module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/5/4-11495a56fca7c8a4eed45dea3bcc613f.jpg";